import { X } from '@music-vine/cadence/icons';
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '@music-vine/cadence/ui';
import { useIsClient } from '@/hooks/ui/useIsClient';
import styles from './styles.module.css';
import type { ReactEventHandler, ReactNode } from 'react';
interface ModalProps {
  children: ReactNode;
  onClose?: ReactEventHandler<HTMLDialogElement>;
}
export const Modal: React.FC<ModalProps> = ({
  children,
  onClose
}) => {
  const modalRef = useRef<HTMLDialogElement | null>(null);
  const isClient = useIsClient();
  useEffect(() => {
    const modal = modalRef?.current;
    if (isClient) {
      modal?.showModal();
    }
  }, [isClient]);
  if (!isClient) {
    return null;
  }
  return createPortal(<dialog aria-modal="true" className={styles.modalContainer} onClick={onClose} onClose={onClose} ref={modalRef}>
      <Button borderRadius="full" className={styles.closeButton} icon onClick={(e?: React.MouseEvent<HTMLButtonElement>) => {
      e?.stopPropagation();
      if (onClose) {
        onClose(e as unknown as React.MouseEvent<HTMLDialogElement>);
      }
    }} size="default" variant="light">
        <X />
      </Button>
      <div className={styles.modalContent}>{children}</div>
    </dialog>, document.body);
};